var projectTimeline = {
	"Project timeline": "專案時間軸",
	"None planned": "未計劃",
	"1-3 months": "1-3 個月",
	"4-6 months": "4-6 個月",
	"7-12 months": "7-12 個月",
	"More than 1 year": "超過 1 年"
};

export { projectTimeline as default };
